import { digestPosts } from "@/mocks/news";

const catStyle: Record<string, string> = {
  "汽车": "bg-secondary-100 text-secondary-800",
  "社会": "bg-accent-100 text-accent-800",
  "文旅": "bg-primary-100 text-primary-700",
  "生活": "bg-background-200 text-foreground-700",
};

export default function DigestSection() {
  return (
    <section id="digest" className="scroll-mt-32 border-y border-background-200 bg-foreground-950">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="mb-8 flex flex-col sm:flex-row sm:items-end justify-between gap-3">
          <div>
            <span className="inline-flex items-center gap-2 text-xs font-medium text-accent-400">
              <i className="ri-article-line text-base" aria-hidden="true"></i>
              DAILY DIGEST
            </span>
            <h2 className="font-heading mt-2 text-2xl md:text-3xl font-bold text-background-50">
              热点速报
            </h2>
            <p className="mt-2 text-sm text-foreground-300">深度观察与新鲜解读，一分钟看懂一件事</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {digestPosts.map((post) => (
            <a
              key={post.title}
              href="#about"
              className="group flex flex-col sm:flex-row gap-0 overflow-hidden rounded-2xl border border-background-800 bg-foreground-900/60 transition-colors hover:border-foreground-700"
            >
              <div className="relative sm:w-[220px] shrink-0 aspect-[4/3] sm:aspect-auto overflow-hidden">
                <img
                  src={post.image}
                  alt={`${post.title}配图`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-center gap-2">
                  <span className={`whitespace-nowrap rounded px-2 py-0.5 text-[11px] font-medium ${catStyle[post.category]}`}>
                    {post.category}
                  </span>
                  <span className="text-[11px] text-foreground-400">{post.time}</span>
                </div>
                <h3 className="font-heading mt-3 text-lg font-bold leading-snug text-background-50 transition-colors group-hover:text-accent-300">
                  {post.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-300">
                  {post.excerpt}
                </p>
                <span className="mt-auto pt-3 inline-flex items-center gap-1 text-xs font-medium text-accent-400">
                  阅读全文 <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}